import React from 'react';
import FallbackImage from '../FallbackImage/FallbackImage';

const ProductCard = ({ product }) => {
  return (
    <div className="relative group w-128 h-128 mx-auto my-4 bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer">
      {/* Product Image */}
      <div className="w-full h-full relative bg-[#F3F4F6] flex items-center justify-center">
        <FallbackImage
          src={`/media/${product.image}`}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
          placeholderText={product.name}
        />

        {/* Product Name */}
        <div className="absolute bottom-0 left-0 right-0 text-white text-center text-lg font-semibold py-2 bg-black/60">
          {product.name}
        </div>
      </div>

      {/* Sliding Transparent Card */}
      <div className="absolute bottom-0 left-0 right-0 backdrop-blur-md bg-black/60 border border-white/30 text-white p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out">
        <div className="space-y-4">
          {/* Features */}
          <div className="space-y-2">
            {product.features.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="w-1.5 h-1.5 bg-orange-400 rounded-full flex-shrink-0 shadow-sm"></div>
                <span className="text-base font-medium drop-shadow-md">{feature}</span>
              </div>
            ))}
          </div>

          {/* Weight Badge inside overlay */}
          <div className="text-center">
            <span className="inline-block bg-orange-500/90 text-white font-semibold py-2 px-4 rounded-lg border border-orange-400/30">
              {product.meta.weight}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
